import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { FocusMeDirective } from '../../../../shared/directives/focus-me.directive';

export interface DialogRequestCertificateData {
	guaranteeName: string;
}

@Component({
	selector: 'copo-dialog-request-certificate',
	templateUrl: './dialog-request-certificate.component.html',
	styleUrl: './dialog-request-certificate.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule, MatIconModule, MatButtonModule, FocusMeDirective, MatDialogModule]
})
export class DialogRequestCertificateComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) readonly data: DialogRequestCertificateData,
		private readonly dialogRef: MatDialogRef<DialogRequestCertificateComponent, boolean>
	) {}

	evtCancel() {
		this.dialogRef.close(false);
	}

	evtConfirm() {
		this.dialogRef.close(true);
	}
}
